import { render } from "./CardCharacter.vue?vue&type=template&id=efccaa3a"
import script from "./CardCharacter.vue?vue&type=script&lang=js"
export * from "./CardCharacter.vue?vue&type=script&lang=js"

import "./CardCharacter.vue?vue&type=style&index=0&id=efccaa3a&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__